export const contentData = {
    spanish: {
        title: 'Subproceso',
        button: 'Continuar',
        back:'Regresar',
        responsible_banner: {
            responsible: 'responsible',
            responsible_id: 'responsible_id',
            completed_date: 'completed_date'
        },
        accordions: [
            {
                id: 'payroll_revision',
                title: 'Revisión de nómina'
            },
            {
                id: 'calculation_sent_to_client',
                title: 'Envío de Cálculo de Nómina'
            },
        ],
    }
}
